<template>
  <p class="vouchers-list-item-empty">
    No attempt history
  </p>
</template>

<script>
export default {
  name: 'VouchersListItemAttemptEmpty',
}
</script>

<style lang="scss">
.vouchers-list-item-empty {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 14px;
  color: var(--white);
  margin: 20px 0;
  @include tablet {
    margin: 0;
  }
}
</style>
